export default "__VITE_ASSET__BWLkH_$2__"